// extracted by mini-css-extract-plugin
module.exports = {"versionList":"nUwaYmq_","versionTag":"M7MuWfNM","title":"HLNl4UH_","desc":"__4VwReyla","content":"CimUlZcg","item":"IeRG3alN"};